<template>
    <div>
        <page-loading v-if="!item" />
        <page-title v-if="item" title="Edit Collection Set" :helpLink="{ path: '/pages/station-collector-help', hash: 'AllergenCollectionSet_Edit' }" />
        <b-alert v-if="item" :show="item && item.notificationsSent" variant="info" dismissable>
            Notifications were already been sent (on {{item.notificationsSent}}) for this station and date.
        </b-alert>
        <allergen-collection-set-fields :item="item" v-on:submit="onSubmit" v-on:cancel="onCancel" v-if="item">
            <template v-slot:save>
                {{ sendNotifications ? 'Save and Send Email Notifications' : 'Save' }}
            </template>
        </allergen-collection-set-fields>
        <b-form-checkbox v-if="item && !item.notificationsSent" v-model="sendNotifications">Send Notification Emails</b-form-checkbox>
    </div>
</template>

<script>
    import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'

    export default {
        name: "AllergenCollectionSetEdit",
        mixins: [CrudOperationsMixin],
        props: ['id'],
        data() {
            return {
                item: null,
                sendNotifications: true
            };
        },
        computed: {
        },
        methods: {
            load: function () {

                this.readQuery('/graphql/management', {
                    query: `
          query ($id: ID) {
            allergenCollectionSet (id: $id) {
              id,
              concurrencyCheck,
              station {
                id,
                name,
                displayCity,
                stationAllergens {
                  id,
                  allergen {
                    id,
                    category,
                    commonName,
                    name,
                    family,
                    imageName
                  }
                },
                scaleSet {
                  id,
                  scales {
                    category,
                    range1Begin,
                    range2Begin,
                    range3Begin,
                    range4Begin
                  }
                }
              },
              date,
              comment,
              weatherNotes,
              isCommentPublic,
              notificationsSent,
              allergenCollections {
                id,
                concurrencyCheck,
                value,
                allergen {
                  id,
                  category
                }
              }
            }
          }`,
                    variables: {
                        'id': this.id
                    }
                }, (data) => {
                    this.item = data.allergenCollectionSet;
                    this.sendNotifications = this.item.notificationsSent; //Controls Send Notification Emails Checkbox (!= checks the check box)
                    this.item.station.stationAllergens.forEach(sa => {
                        let y = this.item.allergenCollections.filter(z => z.allergen.id == sa.allergen.id);
                        if (y.length == 0) {
                            this.item.allergenCollections.push({
                                value: '',
                                allergen: {
                                    id: sa.allergen.id,
                                    category: sa.allergen.category
                                }
                            });
                        }
                    });

                    this.item.station.stationAllergens = this.item.station.stationAllergens.sort((a, b) => {
                        if (a.allergen.category == 'UNIDENTIFIED')
                            return 1;
                        else if (b.allergen.category == 'UNIDENTIFIED')
                            return -1;
                        else if (a.allergen.category < b.allergen.category)
                            return -1;
                        else if (a.allergen.category > b.allergen.category)
                            return 1;
                        else if (a.allergen.showAtEndOfList)
                            return 1;
                        else if (b.allergen.showAtEndOfList)
                            return -1;
                        else if (a.allergen.commonName < b.allergen.commonName)
                            return -1;
                        else if (a.allergen.commonName > b.allergen.commonName)
                            return 1;
                        else if (a.allergen.name < b.allergen.name)
                            return -1;
                        else if (a.allergen.name > b.allergen.name)
                            return 1;
                        else
                            return 0;
                    });
                });
            },
            onCancel(evt) {
                this.$router.push('/allergenCollectionSet');
            },
            onSubmit(evt) {
                let variables = {
                    'id': this.id,
                    'allergenCollectionSet': {
                        id: this.item.id,
                        concurrencyCheck: this.item.concurrencyCheck,
                        comment: this.item.comment,
                        weatherNotes: this.item.weatherNotes,
                        date: this.item.date,
                        isCommentPublic: this.item.isCommentPublic,
                        stationId: this.item.station.id,
                        notificationsSent: this.item.notificationsSent
                    }
                };

                let params = [];
                let mutations = [];

                params.push('$id: ID!');
                params.push('$allergenCollectionSet: AllergenCollectionSetUpdateInputOGT!');

                let idx = 0;
                this.item.allergenCollections.forEach(ac => {
                    if (ac.value === parseInt(ac.value)) {
                        if (ac.id) {
                            params.push('$id' + idx + ': ID!');
                            params.push('$allergenCollection' + idx + ': AllergenCollectionUpdateInputOGT!');
                            mutations.push(`updateAllergenCollection` + idx + `: updateAllergenCollection(id: $id` + idx + `, allergenCollection: $allergenCollection` + idx + `) { id }`);
                            variables['id' + idx] = ac.id;
                            variables['allergenCollection' + idx] = {
                                id: ac.id,
                                value: ac.value,
                                concurrencyCheck: ac.concurrencyCheck,
                                allergenId: ac.allergen.id,
                                allergenCollectionSetId: this.item.id
                            };
                        } else {
                            params.push('$allergenCollection' + idx + ': AllergenCollectionCreateInputOGT!');
                            mutations.push(`createAllergenCollection` + idx + `: createAllergenCollection(allergenCollection: $allergenCollection` + idx + `) { id }`);
                            variables['allergenCollection' + idx] = {
                                value: ac.value,
                                allergenId: ac.allergen.id,
                                allergenCollectionSetId: this.item.id
                            };
                        }
                    }
                    ++idx;
                });

                let mutationName = 'updateAllergenCollectionSet';
                if (!this.sendNotifications)
                    mutationName = 'updateAllergenCollectionSetWithoutNotifications'

                mutations.push(`
          ` + mutationName + `(id: $id, allergenCollectionSet: $allergenCollectionSet) {
            id
          }`);

                this.updateQuery('/graphql/management', {
                    query: `
          mutation (` + params.join(', ') + `) {
            ` + mutations.join(', ') + `
          }`,
                    variables: variables
                }, () => {
                    this.$router.push('/allergenCollectionSet');
                }, null, 'Allergen Collection Set', this.item.station.name + ' (' + this.item.date + ')');
            }
        },
        mounted() {
            this.load();
            // Use this instead of the previous line to test the "Loading" bar
            //window.setTimeout(this.load, 3000);
        }
    };
</script>